
import { motion } from 'framer-motion';
import { useMemo } from 'react';

const HeroSection = () => {
  const scrollToContent = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  const currentMonth = useMemo(() => new Date().getMonth() + 1, []);

  const isSakuraSeason = currentMonth >= 3 && currentMonth <= 5;
  const isSnowSeason = currentMonth >= 12 || currentMonth <= 2;

  const backgroundImage = isSakuraSeason
    ? 'https://static.readdy.ai/image/266bb3bc7ccfcec14fddb7759900fdba/c451d682daac6906865a96a6402c9fda.jpeg'
    : isSnowSeason
    ? 'https://static.readdy.ai/image/266bb3bc7ccfcec14fddb7759900fdba/f1c8b08f57e7a7c3c648c1adef077a17.jpeg'
    : 'https://static.readdy.ai/image/266bb3bc7ccfcec14fddb7759900fdba/44f90fc846066bf85af4886fda3ddcc7.jpeg';

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${backgroundImage}')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="relative z-10 text-center"
      >
        <h1 className="font-serif text-white mb-4">
          <div className="text-7xl font-bold tracking-widest mb-2" style={{ writingMode: 'horizontal-tb' }}>
            大石神社
          </div>
          <div className="h-[1px] w-32 bg-[#D4AF37] mx-auto my-6"></div>
          <div className="text-lg tracking-[0.3em] text-[#D4AF37] font-normal">
            OISHI JINJA
          </div>
        </h1>

        <p className="text-white/90 text-lg tracking-wide mt-8 leading-relaxed">
          忠臣蔵ゆかりの聖地<br />
          京都山科に佇む歴史ある神社
        </p>
      </motion.div>

      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        onClick={scrollToContent}
        className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10 cursor-pointer"
      >
        <div className="w-12 h-12 rounded-full border border-white/50 flex items-center justify-center hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all">
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </div>
      </motion.button>
    </section>
  );
};

export default HeroSection;
